/**
 * White Label branding loader.
 * On custom domains, fetches branding from API and injects CSS variables + meta.
 * On platform domains, does nothing (default BWClients branding).
 */

const PLATFORM_DOMAINS = ['app.bwclients.ru', 'localhost', '127.0.0.1'];

function isPlatformDomain() {
    const host = location.hostname;
    return PLATFORM_DOMAINS.some(d => host === d || host.endsWith('.' + d));
}

let _branding = null;

export function getBranding() {
    return _branding;
}

export async function loadBranding() {
    if (isPlatformDomain()) return null;

    // Check sessionStorage cache first
    const cached = sessionStorage.getItem('bwc_wl_branding');
    if (cached) {
        try {
            _branding = JSON.parse(cached);
            applyBranding(_branding);
            return _branding;
        } catch { /* ignore */ }
    }

    try {
        const res = await fetch(`/api/v1/whitelabel/branding?domain=${encodeURIComponent(location.hostname)}`);
        const json = await res.json();
        if (json.success && json.data) {
            _branding = json.data;
            sessionStorage.setItem('bwc_wl_branding', JSON.stringify(_branding));
            applyBranding(_branding);
            return _branding;
        }
    } catch {
        // Silently fail — default branding will be used
    }

    return null;
}

function applyBranding(b) {
    if (!b) return;

    const root = document.documentElement;

    // CSS custom properties
    if (b.primary_color) {
        root.style.setProperty('--color-primary', b.primary_color);
        root.style.setProperty('--color-primary-600', b.primary_color);
        // Derive lighter/darker variants
        root.style.setProperty('--color-primary-50', b.primary_color + '10');
        root.style.setProperty('--color-primary-100', b.primary_color + '20');
        root.style.setProperty('--color-primary-500', b.primary_color);
        root.style.setProperty('--color-primary-700', darken(b.primary_color, 15));
    }

    if (b.accent_color) {
        root.style.setProperty('--color-accent', b.accent_color);
    }

    // Title
    if (b.app_name) {
        document.title = b.app_name;
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) metaDesc.content = `${b.app_name} — система управления`;
    }

    // Favicon
    if (b.favicon_url) {
        let link = document.querySelector('link[rel="icon"]');
        if (link) link.href = b.favicon_url;
    }

    // Custom CSS
    if (b.custom_css) {
        const style = document.createElement('style');
        style.id = 'wl-custom-css';
        style.textContent = b.custom_css;
        document.head.appendChild(style);
    }
}

function darken(hex, percent) {
    const num = parseInt(hex.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent);
    const R = Math.max((num >> 16) - amt, 0);
    const G = Math.max((num >> 8 & 0x00FF) - amt, 0);
    const B = Math.max((num & 0x0000FF) - amt, 0);
    return '#' + (0x1000000 + R * 0x10000 + G * 0x100 + B).toString(16).slice(1);
}

/** Clear branding cache (call when switching accounts) */
export function clearBrandingCache() {
    sessionStorage.removeItem('bwc_wl_branding');
    _branding = null;
}
